import { Wall } from "../jsonParse";
import * as marietta from '../../';
import { BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../../webcad/Constants';

/** 
 * 天井高の設定 
 * */  
export class decideCeilingHeight {

    constructor(private buildingType: number, private walls: Wall[][], public maxCeiling: number) {
        ;
    }

    public execute() {

        let tenjo1f = 0;
        let tenjo2f = 0;
        let tenjo3f = 0;

        for (let floor = 0; floor < this.walls.length; floor++) {
            let ceilingHeight = 0;
            this.walls[floor].forEach((wall: Wall) => {
    
                const height = wall.dimensions[1] * 1000;
                /** 天井高が2500mmより大きい場合は、吹き抜けの場合があるため無視 */
                if (height > this.maxCeiling) return;
    
                ceilingHeight = Math.max(...[ceilingHeight, height]);
    
            });

            /** 天井高がすべて2500mm以上なら、2500mmに設定 */
            if (ceilingHeight == 0) ceilingHeight = 2500;

            if (floor == 0) tenjo1f = ceilingHeight;
            if (floor == 1) tenjo2f = ceilingHeight;
            if (floor == 2) tenjo3f = ceilingHeight;

        }

        /** 天井高の設定 */  
        this.setParam(String(Math.round(tenjo1f)), String(Math.round(tenjo2f)), String(Math.round(tenjo3f)));
    }

    /** 天井高の設定を行う */   
    private setParam(tenjo1f: string, tenjo2f: string, tenjo3f: string) {
        
        const height1f: string = '3405';
        const floor1: string = '40';

        const height2f: string = '2820';
        const floor2: string = '40';

        const height3f: string = '2800';
        const floor3: string = '40';

        const yukadaka1f: string = '565';

        const kisopakkin: string = '0';
        const kisodaka: string = this.buildingType == BUILDING_TYPE_HOUSE ? '400' : '480';

        const genkandaka: string = this.buildingType == BUILDING_TYPE_HOUSE ? '335' : '385';

        marietta.webcad.WebCADGlobal.autoMain.SetDesignHigh(height1f, tenjo1f, floor1, height2f, tenjo2f, floor2, height3f, tenjo3f, floor3, yukadaka1f, kisopakkin, kisodaka, genkandaka);

        /** 2D連携 */  
        const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
        marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
    }

}